<ion-content>
  <ion-grid style="margin: 3px">
    <!-- Tenant Selection -->
    <ion-row *ngIf="!selectedTenant">
      <ion-col>
        <ion-card>
          <ion-card-header>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div>
                <ion-card-title>Select Tenant</ion-card-title>
                <ion-card-subtitle
                  >Click a tenant to view its taxonomy
                  dashboard</ion-card-subtitle
                >
              </div>
              <ion-searchbar
                mode="ios"
                class="rounded-search-bar"
                placeholder="Search tenants..."
                showCancelButton="never"
                [value]="tenantSearchText"
                (ionInput)="tenantSearchText = $event.target.value"
                style="width: 270px; margin: 0"
              >
              </ion-searchbar>
            </div>
          </ion-card-header>
          <ion-card-content>
            <ngx-datatable
              #tenantTable
              [rows]="
                tenants$
                  | async
                  | filterCollection
                    : tenantSearchText
                    : ['name', 'id', 'subdomain']
              "
              [columns]="tenantColumns"
              [columnMode]="ColumnMode.flex"
              [headerHeight]="50"
              [footerHeight]="0"
              [rowHeight]="60"
              [limit]="1000"
              [selectionType]="SelectionType.single"
              [selected]="selected"
              (select)="onTenantSelect($event)"
              class="material tenant-selection-table"
              [loadingIndicator]="isLoadingTenants"
              [trackByProp]="'id'"
              [sortType]="'single'"
              [externalSorting]="false"
              [cssClasses]="{
                sortAscending: 'fa fa-sort-asc',
                sortDescending: 'fa fa-sort-desc',
                sortUnset: 'fa fa-sort'
              }"
            >
            </ngx-datatable>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row
      *ngIf="selectedTenant"
      class="ion-justify-content-between ion-align-items-center"
      style="margin-bottom: 2rem"
    >
      <ion-col>
        <h1>Taxonomy Classification Dashboard</h1>
        <p style="margin: 0.25rem 0 0 0; font-size: 0.9rem">
          Monitor the progress of automatic article categorization for
          {{ selectedTenant.name }}
        </p>
        <ion-button fill="clear" size="small" (click)="clearTenantSelection()">
          <ion-icon name="arrow-back-outline" slot="start"></ion-icon>
          Back to Dimensions
        </ion-button>
      </ion-col>
      <ion-col size="auto">
        <div style="display: flex; gap: 0.5rem">
          <!-- Dimension-specific actions (only show when dimension is selected) -->
          <ng-container *ngIf="selectedDimension">
            <ion-button
              color="primary"
              (click)="startTaxonomyOnboarding()"
              [disabled]="isLoading"
            >
              <ion-icon name="play-outline" slot="start"></ion-icon>
              Start Onboarding
            </ion-button>
            <ion-button
              color="danger"
              fill="outline"
              (click)="resetTaxonomy()"
              [disabled]="isLoading"
            >
              <ion-icon name="trash-outline" slot="start"></ion-icon>
              Reset Taxonomy
            </ion-button>
            <ion-button
              color="secondary"
              fill="outline"
              (click)="viewDimensionalAnalysis()"
              [disabled]="isLoading"
            >
              <ion-icon name="analytics-outline" slot="start"></ion-icon>
              Dimensional Analysis
            </ion-button>
          </ng-container>

          <!-- Global actions (always available when tenant is selected) -->
          <ion-button
            fill="outline"
            (click)="onRefresh()"
            [disabled]="isLoading"
          >
            <ion-icon name="refresh-outline" slot="start"></ion-icon>
            Refresh
          </ion-button>
        </div>
      </ion-col>
    </ion-row>

    <div *ngIf="selectedTenant">
      <ion-row *ngIf="error">
        <ion-col>
          <ion-item color="danger">
            <ion-icon name="warning-outline" slot="start"></ion-icon>
            {{ error }}
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row
        *ngIf="isLoading"
        class="ion-justify-content-center"
        style="padding: 3rem"
      >
        <ion-col size="auto" class="ion-text-center">
          <ion-spinner color="primary"></ion-spinner>
          <p style="margin-top: 1rem">Loading taxonomy statistics...</p>
        </ion-col>
      </ion-row>

      <!-- Available Dimensions (only show when no dimension is selected) -->
      <ion-row
        *ngIf="selectedTenant && !selectedDimension && !isLoadingDimensions"
      >
        <ion-col>
          <ion-card>
            <ion-card-header>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div>
                  <ion-card-title>Available Dimensions</ion-card-title>
                  <ion-card-subtitle
                    >Select a dimension to view its classification
                    data</ion-card-subtitle
                  >
                </div>
                <ion-button
                  fill="outline"
                  size="small"
                  (click)="createDimension()"
                >
                  <ion-icon name="add-outline" slot="start"></ion-icon>
                  New Dimension
                </ion-button>
              </div>
            </ion-card-header>
            <ion-card-content>
              <div
                *ngIf="dimensions.length === 0"
                style="text-align: center; padding: 2rem"
              >
                <ion-icon
                  name="cube-outline"
                  style="font-size: 2rem; opacity: 0.5; margin-bottom: 1rem"
                ></ion-icon>
                <p style="margin: 0">
                  No dimensions found. Create your first dimension to start
                  classification.
                </p>
              </div>

              <div *ngIf="dimensions.length > 0">
                <ion-item
                  *ngFor="
                    let dimension of dimensions;
                    trackBy: trackByDimension
                  "
                  lines="full"
                >
                  <ion-label>
                    <h3>{{ dimension.name }}</h3>
                    <p>
                      <ion-chip
                        [color]="getStrategyColor(dimension.strategy)"
                        size="small"
                      >
                        {{ getStrategyLabel(dimension.strategy) }}
                      </ion-chip>
                      <ion-chip
                        *ngIf="dimension.role"
                        color="medium"
                        size="small"
                      >
                        {{ dimension.role }}
                      </ion-chip>
                      <ion-chip
                        [color]="getDimensionStatusColor(dimension)"
                        size="small"
                      >
                        {{ getDimensionStatusText(dimension) }}
                      </ion-chip>
                    </p>
                    <p
                      style="font-size: 0.8rem; color: var(--ion-color-medium)"
                    >
                      LLM: {{ dimension.llmThreshold }} | Centroid:
                      {{ dimension.centroidThreshold }} | Aggregation:
                      {{ dimension.aggregationThreshold }}
                    </p>
                  </ion-label>
                  <div
                    slot="end"
                    style="display: flex; flex-direction: column; gap: 0.5rem"
                  >
                    <ion-button
                      fill="clear"
                      size="small"
                      [color]="
                        selectedDimension?.id === dimension.id
                          ? 'primary'
                          : 'medium'
                      "
                      (click)="selectDimension(dimension)"
                    >
                      {{
                        selectedDimension?.id === dimension.id
                          ? "Selected"
                          : "Select"
                      }}
                    </ion-button>
                    <ion-button
                      fill="clear"
                      size="small"
                      [color]="dimension.isActive ? 'warning' : 'success'"
                      (click)="toggleDimensionActive(dimension)"
                    >
                      {{ dimension.isActive ? "Deactivate" : "Activate" }}
                    </ion-button>
                  </div>
                </ion-item>
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <!-- Multi-Dimensional Summary (tenant main view only) -->
      <ion-row
        *ngIf="selectedTenant && !selectedDimension && !isLoading && stats"
      >
        <ion-col>
          <ion-card>
            <ion-card-header>
              <ion-card-title>Multi-Dimensional Summary</ion-card-title>
              <ion-card-subtitle
                >Overview across all taxonomy dimensions</ion-card-subtitle
              >
            </ion-card-header>
            <ion-card-content>
              <ion-grid>
                <ion-row class="ion-text-center">
                  <ion-col>
                    <div
                      style="
                        font-size: 1.5rem;
                        font-weight: 600;
                        line-height: 1.2;
                      "
                    >
                      {{ stats.taxonomyStats.summary.totalDimensions }}
                    </div>
                    <div style="font-size: 0.8rem; margin-top: 0.25rem">
                      Total Dimensions
                    </div>
                  </ion-col>
                  <ion-col>
                    <div
                      style="
                        font-size: 1.5rem;
                        font-weight: 600;
                        line-height: 1.2;
                      "
                    >
                      {{ stats.taxonomyStats.summary.activeDimensions }}
                    </div>
                    <div style="font-size: 0.8rem; margin-top: 0.25rem">
                      Active
                    </div>
                  </ion-col>
                  <ion-col>
                    <div
                      style="
                        font-size: 1.5rem;
                        font-weight: 600;
                        line-height: 1.2;
                      "
                    >
                      {{ stats.taxonomyStats.summary.completedDimensions }}
                    </div>
                    <div style="font-size: 0.8rem; margin-top: 0.25rem">
                      Completed
                    </div>
                  </ion-col>
                  <ion-col>
                    <div
                      style="
                        font-size: 1.5rem;
                        font-weight: 600;
                        line-height: 1.2;
                      "
                    >
                      {{
                        stats.taxonomyStats.summary.completedDimensions ===
                          stats.taxonomyStats.summary.activeDimensions &&
                        stats.taxonomyStats.summary.activeDimensions > 0
                          ? "Complete"
                          : "In Progress"
                      }}
                    </div>
                    <div style="font-size: 0.8rem; margin-top: 0.25rem">
                      Overall Status
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="!isLoading && !error && stats && selectedDimension">
        <ion-col size="12" size-md="6">
          <!-- Overview Card -->
          <ion-card>
            <ion-card-header>
              <ion-card-title
                >{{ selectedDimension.name }} Overview</ion-card-title
              >
              <ion-card-subtitle>
                Dimension Classification Progress
              </ion-card-subtitle>
            </ion-card-header>
            <ion-card-content>
              <ng-container *ngIf="getSelectedDimensionStats() as dimStats">
                <div style="margin-bottom: 2rem">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      margin-bottom: 0.5rem;
                    "
                  >
                    <span style="font-weight: 500"
                      >Classification Progress</span
                    >
                    <span style="font-weight: 600"
                      >{{ dimStats.progressPercent }}%</span
                    >
                  </div>
                  <ion-progress-bar
                    [value]="dimStats.progressPercent / 100"
                    [color]="getStatusColor(dimStats.progressPercent)"
                  >
                  </ion-progress-bar>
                  <div style="text-align: center; margin-top: 1rem">
                    <ion-chip
                      [color]="getStatusColor(dimStats.progressPercent)"
                    >
                      {{ getStatusText(dimStats.progressPercent) }}
                    </ion-chip>
                  </div>
                </div>

                <ion-grid>
                  <ion-row class="ion-text-center">
                    <ion-col>
                      <div
                        style="
                          font-size: 2rem;
                          font-weight: 700;
                          line-height: 1.2;
                        "
                      >
                        {{ dimStats.totalArticles }}
                      </div>
                      <div style="font-size: 0.875rem; margin-top: 0.25rem">
                        Total Articles
                      </div>
                    </ion-col>
                    <ion-col>
                      <div
                        style="
                          font-size: 2rem;
                          font-weight: 700;
                          line-height: 1.2;
                        "
                      >
                        {{ dimStats.classifiedArticles }}
                      </div>
                      <div style="font-size: 0.875rem; margin-top: 0.25rem">
                        Classified
                      </div>
                    </ion-col>
                    <ion-col>
                      <div
                        style="
                          font-size: 2rem;
                          font-weight: 700;
                          line-height: 1.2;
                        "
                      >
                        {{
                          dimStats.totalArticles - dimStats.classifiedArticles
                        }}
                      </div>
                      <div style="font-size: 0.875rem; margin-top: 0.25rem">
                        Remaining
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ng-container>
            </ion-card-content>
          </ion-card>
        </ion-col>

        <ion-col size="12" size-md="6" *ngIf="selectedDimension">
          <!-- Selected Dimension Details Card -->
          <ion-card>
            <ion-card-header>
              <ion-card-title
                >{{ selectedDimension.name }} Configuration</ion-card-title
              >
              <ion-card-subtitle
                >Settings for selected dimension</ion-card-subtitle
              >
            </ion-card-header>
            <ion-card-content>
              <div style="margin-bottom: 1.5rem">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 1rem;
                  "
                >
                  <span style="font-weight: 500">Strategy</span>
                  <ion-chip
                    [color]="getStrategyColor(selectedDimension.strategy)"
                  >
                    {{ getStrategyLabel(selectedDimension.strategy) }}
                  </ion-chip>
                </div>
                <div
                  *ngIf="stats.strategySettings.strategyDescriptions"
                  style="
                    font-size: 0.8rem;
                    color: var(--ion-color-medium);
                    margin-bottom: 1rem;
                  "
                >
                  {{
                    stats.strategySettings.strategyDescriptions[
                      selectedDimension.strategy
                    ]
                  }}
                </div>
              </div>

              <!-- Confidence Thresholds -->
              <div style="margin-bottom: 1rem">
                <h4
                  style="
                    margin: 0 0 0.5rem 0;
                    font-size: 0.9rem;
                    font-weight: 600;
                  "
                >
                  Confidence Thresholds
                </h4>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    font-size: 0.8rem;
                    margin-bottom: 0.25rem;
                  "
                >
                  <span>LLM: {{ selectedDimension.llmThreshold }}</span>
                  <span
                    >Centroid: {{ selectedDimension.centroidThreshold }}</span
                  >
                  <span
                    >Aggregation:
                    {{ selectedDimension.aggregationThreshold }}</span
                  >
                </div>
              </div>

              <div style="font-size: 0.75rem; opacity: 0.7; text-align: center">
                Dimension settings can be updated via the Manage Dimensions
                panel
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>

        <ion-col size="12">
          <!-- Categories Card -->
          <ion-card *ngIf="getSelectedDimensionStats() as dimStats">
            <ion-card-header>
              <ion-card-title>Categories</ion-card-title>
              <ion-card-subtitle
                >{{ dimStats.categories.length }} categories in
                {{ selectedDimension.name }}</ion-card-subtitle
              >
            </ion-card-header>
            <ion-card-content>
              <div
                *ngIf="dimStats.categories.length === 0"
                style="text-align: center; padding: 2rem"
              >
                <ion-icon
                  name="folder-outline"
                  style="font-size: 2rem; opacity: 0.5; margin-bottom: 1rem"
                ></ion-icon>
                <p style="margin: 0">
                  No categories found. Articles may not be classified yet for
                  this dimension.
                </p>
              </div>
              <div
                *ngIf="dimStats.categories.length > 0"
                style="max-height: 400px; overflow-y: auto"
              >
                <ion-item
                  *ngFor="
                    let category of dimStats.categories;
                    trackBy: trackByCategory
                  "
                  lines="none"
                  style="padding: 0.75rem 0; cursor: pointer"
                  (click)="viewCategoryAnalysis(category.category)"
                >
                  <ion-label>
                    <span style="font-weight: 500">{{
                      category.category
                    }}</span>
                  </ion-label>
                  <ion-chip slot="end" color="medium">
                    {{ category.articleCount }}
                  </ion-chip>
                  <ion-icon
                    name="chevron-forward-outline"
                    slot="end"
                    style="margin-left: 0.5rem; opacity: 0.5"
                  ></ion-icon>
                </ion-item>
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <!-- Detailed Categories with Articles -->
      <ion-row *ngIf="!isLoadingCategories && !error && categories">
        <ion-col>
          <ion-card>
            <ion-card-header>
              <ion-card-title>Categories & Articles</ion-card-title>
              <ion-card-subtitle
                >{{ categories.categories.length }} categories with article
                details</ion-card-subtitle
              >
            </ion-card-header>
            <ion-card-content>
              <div
                *ngIf="categories.categories.length === 0"
                style="text-align: center; padding: 2rem"
              >
                <ion-icon
                  name="document-outline"
                  style="font-size: 2rem; opacity: 0.5; margin-bottom: 1rem"
                ></ion-icon>
                <p style="margin: 0">No categories with articles found.</p>
              </div>

              <div *ngIf="categories.categories.length > 0">
                <div
                  *ngFor="
                    let category of categories.categories;
                    trackBy: trackByCategoryDetailed
                  "
                  style="
                    margin-bottom: 2rem;
                    border: 1px solid var(--ion-color-light);
                    border-radius: 8px;
                    padding: 1rem;
                  "
                >
                  <!-- Category Header -->
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      margin-bottom: 1rem;
                    "
                  >
                    <div
                      style="display: flex; align-items: center; gap: 0.5rem"
                    >
                      <h3 style="margin: 0; font-size: 1.1rem">
                        {{ category.category }}
                      </h3>
                      <ion-chip [color]="getScopeColor(category)" size="small">
                        {{ getScopeLabel(category) }}
                      </ion-chip>
                    </div>
                    <ion-chip color="medium">
                      {{ category.articleCount }} articles
                    </ion-chip>
                  </div>

                  <!-- Articles List -->
                  <div
                    *ngIf="category.articles.length > 0"
                    style="padding-left: 1rem"
                  >
                    <div
                      *ngFor="
                        let article of category.articles;
                        trackBy: trackByArticle
                      "
                      style="margin-bottom: 0.5rem"
                    >
                      <div
                        style="display: flex; align-items: center; gap: 0.5rem"
                      >
                        <button
                          (click)="viewArticleAnalysis(article.id)"
                          style="
                            background: none;
                            border: none;
                            color: var(--ion-color-primary);
                            text-decoration: underline;
                            cursor: pointer;
                            font-weight: 500;
                            padding: 0;
                            text-align: left;
                          "
                        >
                          {{ article.title }}
                        </button>
                        <a
                          [href]="getArticleUrl(article)"
                          target="_blank"
                          style="
                            color: var(--ion-color-secondary);
                            text-decoration: underline;
                            font-size: 0.8rem;
                          "
                        >
                          edit
                        </a>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="category.articles.length === 0"
                    style="padding-left: 1rem; color: var(--ion-color-medium)"
                  >
                    No articles found in this category
                  </div>
                </div>
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row
        *ngIf="isLoadingCategories"
        class="ion-justify-content-center"
        style="padding: 2rem"
      >
        <ion-col size="auto" class="ion-text-center">
          <ion-spinner color="primary"></ion-spinner>
          <p style="margin-top: 1rem">Loading categories...</p>
        </ion-col>
      </ion-row>

      <!-- Metadata -->
      <ion-row *ngIf="!isLoading && !error && stats">
        <ion-col>
          <ion-card>
            <ion-card-content>
              <ion-grid>
                <ion-row>
                  <ion-col size="12" size-md="4">
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        gap: 0.25rem;
                      "
                    >
                      <strong style="font-size: 0.875rem">Description:</strong>
                      <span style="font-weight: 500">{{
                        stats.meta.description
                      }}</span>
                    </div>
                  </ion-col>
                  <ion-col size="12" size-md="4">
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        gap: 0.25rem;
                      "
                    >
                      <strong style="font-size: 0.875rem">Last Updated:</strong>
                      <span style="font-weight: 500">{{
                        stats.meta.lastUpdated | date: "medium"
                      }}</span>
                    </div>
                  </ion-col>
                  <ion-col size="12" size-md="4">
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        gap: 0.25rem;
                      "
                    >
                      <strong style="font-size: 0.875rem">Status:</strong>
                      <span style="font-weight: 500">{{
                        stats.taxonomyStats.summary.completedDimensions ===
                          stats.taxonomyStats.summary.activeDimensions &&
                        stats.taxonomyStats.summary.activeDimensions > 0
                          ? "Complete"
                          : "In Progress"
                      }}</span>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </div>
  </ion-grid>

  <!-- Create Dimension Modal -->
  <ion-modal [isOpen]="showCreateDimensionModal">
    <ng-template>
      <ion-header>
        <ion-toolbar>
          <ion-title>Create New Dimension</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="cancelCreateDimension()">
              <ion-icon name="close" slot="icon-only"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <div style="padding: 1rem">
          <p style="margin-bottom: 1.5rem; color: var(--ion-color-medium)">
            Configure the new taxonomy dimension. Name is optional - a default
            will be generated based on strategy and role.
          </p>

          <ion-item>
            <ion-label position="stacked">Dimension Name (optional)</ion-label>
            <ion-input
              [value]="newDimensionForm.name"
              (ionInput)="newDimensionForm.name = $event.detail.value!"
              placeholder="e.g., Product Categories"
            ></ion-input>
          </ion-item>

          <ion-item>
            <ion-label position="stacked">Role (optional)</ion-label>
            <ion-select
              [value]="newDimensionForm.role"
              (ionChange)="newDimensionForm.role = $event.detail.value"
              placeholder="Select role..."
              interface="popover"
            >
              <ion-select-option value="">None</ion-select-option>
              <ion-select-option value="primary"
                >Primary - Main classification dimension</ion-select-option
              >
              <ion-select-option value="broad"
                >Broad - High-level categorization</ion-select-option
              >
              <ion-select-option value="granular"
                >Granular - Detailed classification</ion-select-option
              >
            </ion-select>
          </ion-item>

          <ion-item>
            <ion-label position="stacked">Strategy *</ion-label>
            <ion-select
              [value]="newDimensionForm.strategy"
              (ionChange)="newDimensionForm.strategy = $event.detail.value"
              placeholder="Select strategy..."
              interface="popover"
            >
              <ion-select-option value="large"
                >Large - Container chunks (~2000 chars) with
                LLM-only</ion-select-option
              >
              <ion-select-option value="small-llm"
                >Small LLM - Content chunks with LLM-only</ion-select-option
              >
              <ion-select-option value="small-centroid"
                >Small Centroid - Content chunks with
                centroid-first</ion-select-option
              >
              <ion-select-option value="small-hybrid"
                >Small Hybrid - Content chunks with hybrid
                classification</ion-select-option
              >
            </ion-select>
          </ion-item>

          <div style="margin-top: 2rem; display: flex; gap: 1rem">
            <ion-button
              expand="block"
              fill="clear"
              (click)="cancelCreateDimension()"
              style="flex: 1"
            >
              Cancel
            </ion-button>
            <ion-button
              expand="block"
              (click)="confirmCreateDimension()"
              style="flex: 1"
            >
              Create Dimension
            </ion-button>
          </div>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
